import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import { DEFAULT_INITIAL_PAGINATION, initialFindAppsState } from "app/pages/sales-intelligence/store/find-apps/constants";
import type { IFindAppsState } from "app/pages/sales-intelligence/store/find-apps/types/state";

import * as ac from "./action-creators";

const findAppsReducer = createReducer<IFindAppsState, ActionType<typeof ac>>(initialFindAppsState)
    .handleAction(
        ac.setActiveAppSourceType,
        (state, { payload }): IFindAppsState => ({
            ...state,
            activeAppSourceType: payload,
        }),
    )
    .handleAction(
        ac.setIsRowSelectionEnabled,
        (state, { payload }): IFindAppsState => ({
            ...state,
            isRowSelectionEnabled: payload,
        }),
    )
    .handleAction(
        ac.setSelectedRows,
        (state, { payload }): IFindAppsState => ({
            ...state,
            selectedRows: payload,
        }),
    )
    .handleAction(
        ac.findAppsUpdateFilters,
        (state, { payload: [key, filters] }): IFindAppsState => ({
            ...state,
            [key]: {
                ...state[key],
                request: {
                    ...state[key].request,
                    ...DEFAULT_INITIAL_PAGINATION,
                    filters,
                },
            },
        }),
    )
    .handleAction(
        ac.findAppsUpdateSearchText,
        (state, { payload: [key, searchText] }): IFindAppsState => ({
            ...state,
            [key]: {
                ...state[key],
                request: {
                    ...state[key].request,
                    ...DEFAULT_INITIAL_PAGINATION,
                    searchText,
                },
            },
        }),
    )
    .handleAction(
        ac.findAppsUpdateSearchParams,
        (state, { payload: [key, paginationParams] }): IFindAppsState => ({
            ...state,
            [key]: {
                ...state[key],
                request: {
                    ...state[key].request,
                    ...paginationParams,
                },
            },
        }),
    )
    .handleAction(
        ac.findAppsUpdateExpandedFilter,
        (state, { payload: [key, filterName] }): IFindAppsState => ({
            ...state,
            [key]: {
                ...state[key],
                expandedFilter: filterName,
            },
        }),
    )
    .handleAction(
        ac.resetFindAppsState,
        (state): IFindAppsState => ({
            ...state,
            ...initialFindAppsState,
        }),
    );

export default findAppsReducer;
